/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : TRENDING NOW V2 CONFIGURATION ADVANCED SECTION - IMAGE FALLBACK : STYLES --------------- ++++++++++ */
export default theme => ({
  imagefallback: {
    '& .imageplaceholder': {
      maxHeight: pxToEm(125)
    },
    '& .imageuploader': {
      display: 'flex',
      '& .inputbutton': {
        width: 'auto', 
        marginRight: pxToEm(8)
      },
      '& img.preview': {
        display: 'none'
      },
      '&.uploading-true': {
        '& .imagepreview': {
          marginTop: pxToEm(4),
          flexDirection: 'row',
          gap: pxToEm(8),
          alignItems: 'baseline'
        },
      },
      '&.uploading-false': {
        '& .imagepreview': {
          display: 'none'
        }
      },
      '& span.type-action': {
        color: '#7A87BC !important',
        '& .text': {
          display: 'none'
        }
      },
      '& button': {
        background: '#FFF',
        color: '#061240',
        border: '1px solid #061240',
        width: 'auto'
      }
    }
  }
});
